import { type UIEventHandler, useState } from 'react';

export const useScrollTop = () => {
  const [scrollTop, setScrollTop] = useState(0);

  const onScroll: UIEventHandler<HTMLDivElement> = (event) => {
    setScrollTop(event.currentTarget.scrollTop);
  };

  return { scrollTop, onScroll };
};
